import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { addAllList } from 'modules/common';
import {
  adverManageList,
  adverManageWrite,
  adverManageEdit,
  adverManageDel,
  adverManageViewList,
} from 'lib/api/goods';
import {
  advrtsPrdtCode,
  mediaItlTpCode,
  scriptTpCode,
  parAuthTpCode,
  imageTpCode,
  advrtsRstCode,
  mediaSizeCode,
} from 'lib/api/code';

import NewInput from 'components/atoms/NewInput';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import TableBtnWrap from 'components/molecules/TableBtnWrap';
import FunctionWrap from 'components/molecules/FunctionWrap';
import NewButton from 'components/molecules/NewButton';
import Modal from 'components/organisms/NewModal';
import SnackbarWrap from 'components/organisms/Snackbar/SnackbarWrap';
import NewCommonFilter from 'components/organisms/NewCommonFilter';
import FilterCollection from 'components/organisms/FilterCollection';
import NewTableContainer from 'components/molecules/NewTable';

const Statistics = () => {
  const { t } = useTranslation();
  const [initialization, setInitialization] = useState(false);

  let initParam = {
    advrtsPrdtCode: 'all',
    mediaItlTpCode: 'all',
    scriptTpCode: 'all',
    parAuthTpCode: 'all',
    sort: 'desc',
    order: 'ADVRTS_DESC',
  };
  const [params, setParams] = useState(initParam);

  let initModal = {
    open: false,
    type: null,
    params: {},
    modalTitle: '',
    confirmBtnTitle: '',
    message: '',
  };
  const [modal, setModal] = useState(initModal);

  const refList = useRef({});
  const initList = {
    advrtsPrdtCode: [],
    mediaItlTpCode: [],
    scriptTpCode: [],
    parAuthTpCode: [],
    advrtsRstCode: [],
    imageTpCode: [],
    mediaSizeCode: [],
    pltfomTpCode: [
      { label: '온라인', value: '01' },
      { label: '모바일', value: '02' },
      { label: 'APP', value: '04' },
      { label: '미승인', value: '05' },
    ],
  };
  const [list, setList] = useState(initList);

  let initSnackbar = {
    open: false,
    variant: 'success',
    message: '',
  };
  const [snackbar, setSnackbar] = useState(initSnackbar);

  const [loading, setLoading] = useState({
    func: true,
    filter: true,
    table: true,
  });

  const initError = {
    advrtsCode: false,
    imageTpCode: false,
    advrtsDesc: false,
  };
  const [error, setError] = useState(initError);

  useEffect(() => {
    // 상품 코드 리스트
    advrtsPrdtCode()
      .then((response) => {
        refList.current = {
          ...refList.current,
          advrtsPrdtCode: response.data.data,
        };
      })
      .catch((error) => {})
      .finally(() => {
        setList({
          ...list,
          ...refList.current,
        });
      });
    advrtsRstCode()
      .then((response) => {
        refList.current = {
          ...refList.current,
          advrtsRstCode: response.data.data,
        };
      })
      .catch((error) => {})
      .finally(() => {
        setList({
          ...list,
          ...refList.current,
        });
      });
    mediaItlTpCode()
      .then((response) => {
        refList.current = {
          ...refList.current,
          mediaItlTpCode: response.data.data,
        };
      })
      .catch((error) => {})
      .finally(() => {
        setList({
          ...list,
          ...refList.current,
        });
      });
    imageTpCode()
      .then((response) => {
        refList.current = {
          ...refList.current,
          imageTpCode: response.data.data,
        };
      })
      .catch((error) => {})
      .finally(() => {
        setList({
          ...list,
          ...refList.current,
        });
      });
    scriptTpCode()
      .then((response) => {
        refList.current = {
          ...refList.current,
          scriptTpCode: response.data.data,
        };
      })
      .catch((error) => {})
      .finally(() => {
        setList({
          ...list,
          ...refList.current,
        });
      });
    parAuthTpCode()
      .then((response) => {
        refList.current = {
          ...refList.current,
          parAuthTpCode: response.data.data,
        };
      })
      .catch((error) => {})
      .finally(() => {
        setList({
          ...list,
          ...refList.current,
        });
      });
    mediaSizeCode()
      .then((response) => {
        refList.current = {
          ...refList.current,
          mediaSizeCode: response.data.data,
        };
      })
      .catch((error) => {})
      .finally(() => {
        setList({
          ...list,
          ...refList.current,
        });
      });
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (
      list.advrtsPrdtCode.length > 0 &&
      list.advrtsRstCode.length > 0 &&
      list.imageTpCode.length > 0 &&
      list.mediaItlTpCode.length > 0 &&
      list.mediaSizeCode.length > 0 &&
      list.parAuthTpCode.length > 0 &&
      list.scriptTpCode.length > 0
    ) {
      setLoading({
        ...loading,
        func: false,
        filter: false,
        table: false,
      });
    }
    // eslint-disable-next-line
  }, [list]);

  /**
   * 필터 초기화 후 값을 바꿈
   */
  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    }
  }, [initialization]);

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    setInitialization(true);
    setParams(initParam);
  };

  const getParam = (newParams) => {
    setParams({
      ...params,
      ...newParams,
    });
  };

  const modalGetParam = (newParams, name) => {
    if (newParams[name] === '' || newParams[name] === 'all') {
      setError({
        ...error,
        [name]: true,
      });
    } else {
      setError({
        ...error,
        [name]: false,
      });
    }
    setModal({
      ...modal,
      params: {
        ...modal.params,
        ...newParams,
      },
    });
  };

  /**
   * 스낵바 닫는 함수
   * 연속 클릭이 들어왔을 때는 기존 스낵바를 유지
   * @param event
   * @param reason
   */
  const handleSnackBarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar({
      ...snackbar,
      open: false,
      message: '',
    });
  };

  /**
   * 테이블 컬럼 추가
   */
  const addColumnList = (() => {
    const result = new Map();
    result.set(0, {
      id: 'MANAGE_ICONS',
      label: t('관리'),
      align: 'center',
      makeRowFunc: (data) => {
        return (
          <TableBtnWrap>
            <NewButton
              name="edit"
              title={t('수정')}
              iconBtn
              icon="faEdit"
              disableRipple
              onClick={(e) => handleModalOpen(e, data)}
            />
            <NewButton
              name="delete"
              title={t('삭제')}
              iconBtn
              icon="faTrashAlt"
              disableRipple
              onClick={(e) => handleModalOpen(e, data)}
            />
          </TableBtnWrap>
        );
      },
    });
    return result;
  })();

  // header 및 body 컬럼 커스텀
  const customized = {
    PLTFOM_TP_NAME: {
      makeHead: (headsMap) => {
        return <>유형 구분</>;
      },
      makeBody: (rowObj, headsMap) => {
        return <>{rowObj['PLTFOM_TP_NAME']}</>;
      },
    },
    NEW_PAGE_MANAGE: {
      merged: true,
    },
    PAR_PRDT_SEQ: {
      merged: true,
    },
  };

  /**
   * modal 열어주는 함수
   */
  const handleModalOpen = (e, row) => {
    const { name } = e.currentTarget;
    let newModal = { ...initModal };
    newModal = {
      ...newModal,
      open: true,
      type: name,
    };
    setError(initError);
    if (name === 'add') {
      newModal = {
        ...newModal,
        modalTitle: '등록',
        confirmBtnTitle: '등록',
        params: {
          parPrdtSeq: '01',
          advrtsCode: '',
          advrtsDesc: '',
          parScrtVal: '',
          imageTpCode: 'all',
          advrtsPrdtCode: 'all',
          pltfomTpCode: 'all',
          mediaItlTpCode: 'all',
          scriptTpCode: '01',
          mediaSizeCode: 'all',
          advrtsRstCode: '99',
          parAuthTpCode: '01',
        },
      };
      setModal({
        ...newModal,
      });
    } else if (name === 'edit') {
      newModal = {
        ...newModal,
        modalTitle: '수정',
        confirmBtnTitle: '수정',
      };
      adverManageViewList({ parPrdtSeq: row['PAR_PRDT_SEQ'] })
        .then((response) => {
          const { data } = response.data;
          newModal = {
            ...newModal,
            params: {
              parPrdtSeq: data['PAR_PRDT_SEQ'],
              advrtsCode: data['ADVRTS_CODE'],
              advrtsDesc: data['ADVRTS_DESC'],
              parScrtVal: data['PAR_SCRT_VAL'],
              imageTpCode: data['IMAGE_CODE'],
              advrtsPrdtCode: data['ADVRTS_PRDT_CODE'],
              pltfomTpCode: data['PLTFOM_TP_CODE'],
              mediaItlTpCode: data['MEDIA_ITL_TP_CODE'],
              scriptTpCode: data['SCRIPT_TP_CODE'],
              mediaSizeCode: data['MEDIA_SIZE_CODE'],
              advrtsRstCode: data['ADVRTS_RST_CODE'],
              parAuthTpCode: data['PAR_AUTH_TP_CODE'],
            },
          };
        })
        .catch((error) => {
          newModal = {
            ...newModal,
            open: false,
          };
          setSnackbar({
            ...snackbar,
            open: true,
            variant: 'error',
            message: error,
          });
        })
        .finally(() => {
          setModal({
            ...newModal,
          });
        });
    } else if (name === 'delete') {
      newModal = {
        ...newModal,
        modalTitle: '삭제',
        confirmBtnTitle: '삭제',
        params: {
          advrtsDesc: row['ADVRTS_DESC'],
          parPrdtSeq: row['PAR_PRDT_SEQ'],
        },
      };
      setModal({
        ...newModal,
      });
    }
  };
  /**
   * 모달 닫아주는 함수
   */
  const handleModalClose = () => {
    let newModal;
    newModal = {
      ...modal,
      open: false,
    };
    setModal(newModal);
  };

  /**
   * 모달에 submit 버튼을 눌렀을 때 실행되는 함수
   */
  const handleSubmit = () => {
    let newModal = { ...modal };
    let newError = { ...error };
    if (newModal.params['advrtsCode'] === '') {
      newError = {
        ...newError,
        advrtsCode: true,
      };
    } else {
      newError = {
        ...newError,
        advrtsCode: false,
      };
    }
    if (newModal.params['imageTpCode'] === 'all') {
      newError = {
        ...newError,
        imageTpCode: true,
      };
    } else {
      newError = {
        ...newError,
        imageTpCode: false,
      };
    }
    if (newModal.params['advrtsDesc'] === '') {
      newError = {
        ...newError,
        advrtsDesc: true,
      };
    } else {
      newError = {
        ...newError,
        advrtsDesc: false,
      };
    }
    if (JSON.stringify(error) !== JSON.stringify(newError)) {
      setError({ ...newError });
    }
    for (let key in newError) {
      if (newError[key]) {
        return;
      }
    }
    if (modal.type === 'add') {
      adverManageWrite(modal.params)
        .then((response) => {
          const { message } = response.data;
          setSnackbar({
            ...snackbar,
            open: true,
            variant: 'success',
            message: message,
          });
          setLoading({
            ...loading,
            table: true,
          });
        })
        .catch((error) => {
          setSnackbar({
            ...snackbar,
            open: true,
            variant: 'error',
            message: error,
          });
        })
        .finally(() => {
          setLoading({
            ...loading,
            table: false,
          });
        });
    } else if (modal.type === 'edit') {
      adverManageEdit(modal.params)
        .then((response) => {
          const { message } = response.data;
          setSnackbar({
            ...snackbar,
            open: true,
            variant: 'success',
            message: message,
          });
          setLoading({
            ...loading,
            table: true,
          });
        })
        .catch((error) => {
          setSnackbar({
            ...snackbar,
            open: true,
            variant: 'error',
            message: error,
          });
        })
        .finally(() => {
          setLoading({
            ...loading,
            table: false,
          });
        });
    } else if (modal.type === 'delete') {
      adverManageDel(modal.params)
        .then((response) => {
          const { message } = response.data;
          setSnackbar({
            ...snackbar,
            open: true,
            variant: 'success',
            message: message,
          });
          setLoading({
            ...loading,
            table: true,
          });
        })
        .catch((error) => {
          setSnackbar({
            ...snackbar,
            open: true,
            variant: 'error',
            message: error,
          });
        })
        .finally(() => {
          setLoading({
            ...loading,
            table: false,
          });
        });
    }
    setModal({
      ...modal,
      open: false,
    });
  };

  return (
    <>
      <FunctionWrap loading={loading.func}>
        <div>
          <NewButton type="modalBtn" name="add" onClick={handleModalOpen}>
            {t('등록')}
          </NewButton>
        </div>
      </FunctionWrap>

      <NewFilterWrap
        loading={loading.filter}
        handleOnReset={loading.filter ? undefined : handleOnReset}
      >
        <NewCommonFilter
          initialization={initialization}
          getParam={getParam}
          params={params}
          useDate={false}
          useExternalFilter={false}
          useDisplayFilter={false}
          pltfomTpCodeDetailFilter={['04', '05']}
        />
        <FilterCollection
          label={t('상품코드')}
          name="advrtsPrdtCode"
          params={params}
          value={params.advrtsPrdtCode}
          type="select"
          list={addAllList(list.advrtsPrdtCode, 'CODE_DESC', 'CODE_ID', 'all')}
          callBack={getParam}
          labelKey="CODE_DESC"
          valueKey="CODE_ID"
        />
        <FilterCollection
          label={t('구현방식')}
          name="mediaItlTpCode"
          params={params}
          value={params.mediaItlTpCode}
          type="select"
          list={addAllList(list.mediaItlTpCode, 'CODE_DESC', 'CODE_ID', 'all')}
          callBack={getParam}
          labelKey="CODE_DESC"
          valueKey="CODE_ID"
        />
        <FilterCollection
          label={t('상품형태')}
          name="scriptTpCode"
          params={params}
          value={params.scriptTpCode}
          type="select"
          list={addAllList(list.scriptTpCode, 'CODE_DESC', 'CODE_ID', 'all')}
          callBack={getParam}
          labelKey="CODE_DESC"
          valueKey="CODE_ID"
        />
        <FilterCollection
          label={t('노출권한')}
          name="parAuthTpCode"
          params={params}
          value={params.parAuthTpCode}
          type="select"
          list={addAllList(list.parAuthTpCode, 'CODE_DESC', 'CODE_ID', 'all')}
          callBack={getParam}
          labelKey="CODE_DESC"
          valueKey="CODE_ID"
        />
      </NewFilterWrap>

      <NewTableContainer
        dataReqPromise={adverManageList}
        params={params}
        getParam={getParam}
        excelTotalRemoval
        loading={loading.table}
        customized={customized}
        addColumnList={addColumnList}
        useTotal={false}
        useFetch={false}
      />

      <Modal
        open={modal.open}
        headerTitle={modal.modalTitle}
        handleClose={handleModalClose}
        confirmBtnTitle={modal.confirmBtnTitle}
        confirmOnClick={handleSubmit}
        useForm={modal.type !== 'delete'}
      >
        {modal.type === 'delete' && (
          <p>
            {modal.params.advrtsDesc}을(를) {t('정말 삭제하시겠습니까?')}
          </p>
        )}
        {modal.type === 'add' || modal.type === 'edit' ? (
          <>
            <tr>
              <th>{t('* 광고코드')}</th>
              <td>
                <NewInput
                  type="tableInput"
                  name="advrtsCode"
                  params={modal.params}
                  value={modal.params.advrtsCode}
                  // className={'formTextField'}
                  callBack={modalGetParam}
                  error={error.advrtsCode}
                />
              </td>
            </tr>
            <tr>
              <th>{t('* 사이즈')}</th>
              <td>
                {list.imageTpCode.length > 0 && (
                  <>
                    {modal.type === 'add' && (
                      <FilterCollection
                        label={t('노출권한')}
                        name="imageTpCode"
                        params={modal.params}
                        value={modal.params.imageTpCode}
                        type="select"
                        list={addAllList(
                          list.imageTpCode,
                          'CODE_DESC',
                          'CODE_ID',
                          'choice'
                        )}
                        callBack={modalGetParam}
                        labelKey="CODE_DESC"
                        valueKey="CODE_ID"
                        error={error.imageTpCode}
                      />
                    )}
                    {modal.type === 'edit' && (
                      <NewInput
                        type="tableInput"
                        name="imageTpCode"
                        params={modal.params}
                        placeholder="선택된 사이즈가 없습니다."
                        value={modal.params.imageTpCode}
                        callBack={modalGetParam}
                        disabled
                      />
                    )}
                  </>
                )}
              </td>
            </tr>
            <tr>
              <th>{t('* 광고설명')}</th>
              <td>
                <NewInput
                  type="tableInput"
                  name="advrtsDesc"
                  params={modal.params}
                  value={modal.params.advrtsDesc}
                  callBack={modalGetParam}
                  error={error.advrtsDesc}
                />
              </td>
            </tr>
            <tr>
              <th>{t('노출형태')}</th>
              <td>
                <FilterCollection
                  label={t('노출형태')}
                  name="advrtsPrdtCode"
                  params={modal.params}
                  value={modal.params.advrtsPrdtCode}
                  type="select"
                  list={addAllList(
                    list.advrtsPrdtCode,
                    'CODE_DESC',
                    'CODE_ID',
                    'choice'
                  )}
                  callBack={modalGetParam}
                  labelKey="CODE_DESC"
                  valueKey="CODE_ID"
                />
              </td>
            </tr>
            <tr>
              <th>{t('디바이스')}</th>
              <td>
                <FilterCollection
                  label={t('디바이스')}
                  name="pltfomTpCode"
                  params={modal.params}
                  value={modal.params.pltfomTpCode}
                  type="select"
                  list={addAllList(
                    list.pltfomTpCode,
                    'label',
                    'value',
                    'choice'
                  )}
                  callBack={modalGetParam}
                  labelKey="label"
                  valueKey="value"
                />
              </td>
            </tr>
            <tr>
              <th>{t('구현방식')}</th>
              <td>
                <FilterCollection
                  label={t('구현방식')}
                  name="mediaItlTpCode"
                  params={modal.params}
                  value={modal.params.mediaItlTpCode}
                  type="select"
                  list={addAllList(
                    list.mediaItlTpCode,
                    'CODE_DESC',
                    'CODE_ID',
                    'choice'
                  )}
                  callBack={modalGetParam}
                  labelKey="CODE_DESC"
                  valueKey="CODE_ID"
                />
              </td>
            </tr>
            <tr>
              <th>{t('상품형태')}</th>
              <td>
                <FilterCollection
                  label={t('상품형태')}
                  name="scriptTpCode"
                  params={modal.params}
                  value={modal.params.scriptTpCode}
                  type="select"
                  list={list.scriptTpCode}
                  callBack={modalGetParam}
                  labelKey="CODE_DESC"
                  valueKey="CODE_ID"
                />
              </td>
            </tr>
            <tr>
              <th>{t('스크립트 사이즈')}</th>
              <td>
                <FilterCollection
                  label={t('스크립트 사이즈')}
                  name="mediaSizeCode"
                  params={modal.params}
                  value={modal.params.mediaSizeCode}
                  type="select"
                  list={addAllList(
                    list.mediaSizeCode,
                    'CODE_DESC',
                    'CODE_ID',
                    'choice'
                  )}
                  callBack={modalGetParam}
                  labelKey="CODE_DESC"
                  valueKey="CODE_ID"
                />
              </td>
            </tr>
            <tr>
              <th>{t('최후의순간')}</th>
              <td>
                <FilterCollection
                  label={t('최후의순간')}
                  name="advrtsRstCode"
                  params={modal.params}
                  value={modal.params.advrtsRstCode}
                  type="select"
                  list={list.advrtsRstCode}
                  callBack={modalGetParam}
                  labelKey="CODE_DESC"
                  valueKey="CODE_ID"
                />
              </td>
            </tr>
            <tr>
              <th>{t('노출권한')}</th>
              <td>
                <FilterCollection
                  label={t('노출권한')}
                  name="parAuthTpCode"
                  params={modal.params}
                  value={modal.params.parAuthTpCode}
                  type="select"
                  list={list.parAuthTpCode}
                  callBack={modalGetParam}
                  labelKey="CODE_DESC"
                  valueKey="CODE_ID"
                />
              </td>
            </tr>
            <tr>
              <th>{t('스크립트 등록결과')}</th>
              <td>
                <NewInput
                  type="tableInput"
                  name="parScrtVal"
                  params={modal.params}
                  value={modal.params.parScrtVal}
                  callBack={modalGetParam}
                />
              </td>
            </tr>
          </>
        ) : null}
      </Modal>
      <SnackbarWrap
        open={snackbar.open}
        onClose={handleSnackBarClose}
        variant={snackbar.variant}
        message={snackbar.message}
      />
    </>
  );
};

export default Statistics;
